import React from 'react';
import {
  Button,
  Box,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  useDisclosure,
} from '@chakra-ui/react';
import LaunchPreviewModal from 'src/components/atoms/launch-preview-modal';

interface LaunchPreviewButtonProps {
  launchPreviewRequested: boolean;
  size?: string;
}

const LaunchPreviewButton = ({ launchPreviewRequested, size = 'sm' }: LaunchPreviewButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleButtonClick = () => {
    if (!launchPreviewRequested) {
      onOpen();
    }
  };

  return (
    <>
      {launchPreviewRequested ? (
        <Popover placement="top">
          <PopoverTrigger>
            <Box>
              <Button
                bg="white"
                color="gray.700"
                border="1px solid"
                borderColor="gray.200"
                data-test="launch-preview-btn"
                cursor="default"
                size={size}
                ml={2}
                _hover={{ bg: 'gray.50', borderColor: 'gray.300' }}
                boxShadow="sm"
                fontWeight="medium"
              >
                On Launch Waitlist
              </Button>
            </Box>
          </PopoverTrigger>
          <PopoverContent bg="blue.50" borderColor="blue.200" maxW="sm">
            <PopoverArrow bg="blue.50" />
            <PopoverBody>
              <Text fontSize="sm" color="blue.700" textAlign="center">
                📧 Look out for an email from Loma letting you know when your site is live!
              </Text>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      ) : (
        <Button
          bg="white"
          color="blue.600"
          border="2px solid"
          borderColor="blue.500"
          data-test="launch-preview-btn"
          onClick={handleButtonClick}
          size={size}
          px={6}
          ml={2}
          _hover={{
            bg: 'blue.50',
            borderColor: 'blue.600',
            transform: 'translateY(-1px)',
          }}
          _active={{
            transform: 'translateY(0)',
          }}
          boxShadow="md"
          fontWeight="semibold"
          transition="all 0.2s"
        >
          Ready to Launch?
        </Button>
      )}

      <LaunchPreviewModal
        isOpen={isOpen}
        onClose={onClose}
        launchPreviewRequested={launchPreviewRequested}
      />
    </>
  );
};

export default LaunchPreviewButton;
